import { ResponsivePie } from '@nivo/pie';
import React from 'react';

import GraphTooltip from '~/views/dashboard/DashboardPage/components/AudiencesSection/components/GraphTooltip';

import { ChartTitle, ChartWrapper } from './AIInsightsUI.styles';
import { PieChartBlock } from './blockTypes';

interface Props {
  block: PieChartBlock;
}

const SimplePieChart = ({ block }: Props) => (
  <div>
    <ChartTitle>{block.title}</ChartTitle>
    <ChartWrapper $height={280}>
      <ResponsivePie
        data={block.data}
        margin={{ top: 20, right: 80, bottom: 20, left: 80 }}
        arcLinkLabelsSkipAngle={10}
        arcLabelsSkipAngle={10}
        animate={true}
        colors={{ scheme: 'oranges' }}
        tooltip={({ datum }) => <GraphTooltip dataKey={`${datum.label}`} count={datum.value} />}
        arcLinkLabelsTextColor="#6b7280"
        arcLinkLabelsColor={{ from: 'color' }}
        theme={{
          labels: { text: { fontSize: 11, fill: '#374151' } },
        }}
      />
    </ChartWrapper>
  </div>
);

export default SimplePieChart;
